/**
 * Phone formatting and validation for Russian numbers (+7).
 */

export function formatPhone(value) {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 0) return "";
  // Force +7 prefix
  let d = digits;
  if (d.startsWith("8")) d = "7" + d.slice(1);
  if (!d.startsWith("7")) d = "7" + d;
  let formatted = "+7";
  if (d.length > 1) formatted += ` (${d.slice(1, 4)}`;
  if (d.length >= 4) formatted += ")";
  if (d.length > 4) formatted += ` ${d.slice(4, 7)}`;
  if (d.length > 7) formatted += `-${d.slice(7, 9)}`;
  if (d.length > 9) formatted += `-${d.slice(9, 11)}`;
  return formatted;
}

export function isValidPhone(phone) {
  const digits = phone.replace(/\D/g, "");
  return digits.length === 11 && digits.startsWith("7");
}

export function getPhoneError(phone) {
  if (!phone || phone.trim() === "") return null; // Empty is not an error (let required handle it)
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 11) return "Введите полный номер (11 цифр)";
  if (digits.length > 11) return "Слишком длинный номер";
  if (!digits.startsWith("7")) return "Номер должен начинаться с +7";
  return null;
}
